let contextPath = process.env.NODE_ENV === "production" ? "/email/api" : "email/api";
let obpmPath = process.env.NODE_ENV === "production" ? "/obpm/api" : "obpm/api";
export default {
  contextPath,
  obpmPath,
};
